import { createAsyncAction, createSyncAction } from "../utils/actionCreators";

export const types = {
  ALTERNAR_MAIS_CARDS: "@@rastreamento/ALTERNAR_MAIS_CARDS",
  ATUALIZAR_FILTROS: "@@rastreamento/ATUALIZAR_FILTROS",
  EXIBIR_FILTROS: "@@rastreamento/EXIBIR_FILTROS",
  SELECIONAR_DISPOSITIVO: "@@rastreamento/SELECIONAR_DISPOSITIVO",
  PESQUISAR: "@@rastreamento/PESQUISAR",
  DOMINIO_EMPRESAS: "@@rastreamento/DOMINIO_EMPRESAS",
  DOMINIO_ROTEIROS: "@@rastreamento/DOMINIO_ROTEIROS",
  CLEAN_RASTREAMENTO_DATA: "@@rastreamento/CLEAN_RASTREAMENTO_DATA",
  ALTERNAR_BOTAO: "@@rastreamento/ALTERNAR_BOTAO",
  LIMPAR_ROTEIROS: "@@rastreamento/LIMPAR_ROTEIROS",
};

export const actions = {
  alternarMaisCards: () => createSyncAction(types.ALTERNAR_MAIS_CARDS),
  selecionarDispositivo: (item) =>
    createSyncAction(types.SELECIONAR_DISPOSITIVO, { item }),
  atualizarFiltros: (filtros) =>
    createSyncAction(types.ATUALIZAR_FILTROS, { filtros }),
  exibirFiltros: (visible) =>
    createSyncAction(types.EXIBIR_FILTROS, { visible }),
  alternarBotao: () => createSyncAction(types.ALTERNAR_BOTAO),

  pesquisar: createAsyncAction(types.PESQUISAR),

  carregarEmpresas: createAsyncAction(types.DOMINIO_EMPRESAS),
  carregarRoteiros: createAsyncAction(types.DOMINIO_ROTEIROS),
  cleanRastreamentoData: () => createSyncAction(types.CLEAN_RASTREAMENTO_DATA),
  limparRoteiros: () => createSyncAction(types.LIMPAR_ROTEIROS),
};
